import React, { useMemo } from 'react';
import styled from 'styled-components';
import { previewGarageServicesByCluster } from '../../utils/garageServiceExpansion';

export default function GarageServicePreview({
  companyType,
  selectedClusters = [],
  fuelSpecialistTypes = [],
}) {
  const clusterIds = useMemo(
    () => (Array.isArray(selectedClusters) ? selectedClusters : [])
      .map(Number)
      .filter((n) => n >= 1 && n <= 10),
    [selectedClusters]
  );

  const groups = useMemo(
    () => previewGarageServicesByCluster({ companyType, selectedClusters, fuelSpecialistTypes }),
    [companyType, selectedClusters, fuelSpecialistTypes]
  );

  const totalServices = groups.reduce((sum, group) => sum + group.services.length, 0);

  if (!clusterIds.length) return null;

  return (
    <Wrap>
      <Title>Auto-expanded services</Title>

      {totalServices === 0 ? (
        <EmptyText>No services to preview for the selected clusters yet.</EmptyText>
      ) : (
        <ClusterList>
          {groups.map((group) => (
            <ClusterItem key={group.clusterId}>
              <ClusterTitle>{group.label}</ClusterTitle>
              <ChipGrid>
                {group.services.map((service) => (
                  <Chip key={`${group.clusterId}-${service}`}>{service}</Chip>
                ))}
              </ChipGrid>
            </ClusterItem>
          ))}
        </ClusterList>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  margin-top: 4px;
`;

const Title = styled.p`
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pp-text);
`;

const ClusterList = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  list-style: disc;
`;

const ClusterItem = styled.li`
  & + & {
    margin-top: 12px;
  }
`;

const ClusterTitle = styled.span`
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--pp-text);
`;

const ChipGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: -18px;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 1.35;
  color: var(--pp-text);
  background: var(--pp-bg, #f8fafc);
  border: 1px solid var(--pp-border);
`;

const EmptyText = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--pp-muted);
`;
